import { useDispatch, useSelector } from "react-redux";
import {
	initGameData as initGameDataAction,
	initGameDataFromExternalEventId as initGameDataFromExternalEventIdAction,
	gameError as gameErrorAction
} from "./actions";
import { useAppContext } from "../app/context";

const useGameContext = () => {
	const dispatch = useDispatch();
	const { redirect } = useAppContext();
	const useGame = () => useSelector((state) => state.game.game);
	const useIsLoading = () => useSelector((state) => state.game.isLoading);

	const initGameData = (eventId) => {
		initGameDataAction(eventId, redirect, dispatch);
	};

	const initGameDataFromExternalEventId = (eventId) => {
		initGameDataFromExternalEventIdAction(eventId, redirect, dispatch);
	};

	const state = {
		game: useGame,
		isLoading: useIsLoading
	};

	const gameError = () => {
		gameErrorAction(dispatch);
	};

	return {
		state,
		initGameData,
		initGameDataFromExternalEventId,
		gameError
	};
};

export { useGameContext };
